import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { cn } from '@shared/utils/cn';

interface SuccessCheckmarkProps {
  onComplete?: () => void;
  size?: 'sm' | 'md' | 'lg';
}

export const SuccessCheckmark = ({
  onComplete,
  size = 'md'
}: SuccessCheckmarkProps) => {
  const sizeMap = {
    sm: { container: 'w-12 h-12', icon: 24 },
    md: { container: 'w-16 h-16', icon: 32 },
    lg: { container: 'w-20 h-20', icon: 40 },
  };

  const { container, icon } = sizeMap[size];

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: [0, 1.2, 1], opacity: 1 }}
      transition={{
        duration: 0.4,
        ease: [0.68, -0.55, 0.265, 1.55]
      }}
      onAnimationComplete={onComplete}
      className={cn(
        'flex items-center justify-center bg-green-500 rounded-full',
        container
      )}
    >
      <Check className="text-white" size={icon} strokeWidth={3} />
    </motion.div>
  );
};

interface SuccessToastProps {
  message: string;
  onClose?: () => void;
}

export const SuccessToast = ({ message, onClose }: SuccessToastProps) => (
  <motion.div
    initial={{ opacity: 0, y: -20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -10 }}
    transition={{ duration: 0.3, ease: 'easeOut' }}
    className="flex items-center space-x-3 bg-green-900/20 border border-green-800 rounded-xl p-4 shadow-lg"
  >
    <SuccessCheckmark size="sm" />
    <span className="text-green-900 font-medium">
      {message}
    </span>
  </motion.div>
);
